import { isEqual } from 'lodash-es';
import { create } from 'zustand';

interface RatePlanStore {
  enableRatePlanIds: Record<string, string[]>;
  initializeRatePlans: (initialValues: Record<string, string[]>) => void;
}

const useRatePlanStore = create<RatePlanStore>((set) => ({
  enableRatePlanIds: {},

  initializeRatePlans: (initialValues) =>
    set((state) => {
      if (!isEqual(state.enableRatePlanIds, initialValues)) {
        return { enableRatePlanIds: initialValues };
      }
      return state;
    })
}));

export default useRatePlanStore;
